/* example mock to modify */
export default class EtrClass {
  constructor({
    etr_type: typeEtrPeriple,
    dynamic_display: floatingBar,
    promote: {
      title,
      field_chapo: shortChapo,
      field_etr_additional_summary: longChapo,
      field_etr_heading_image: imageDesk,
      field_etr_heading_image_rwd: imageRwd,
      field_etr_heading_search: SearchActivation,
      field_etr_hp_blur_layer: blurActivation,
      field_etr_hp_text_color: textColor,
    },
    content: dynamicContent,
  } = {
    promote: {},
  }) {
    this.title = title;
    this.imageDesk = imageDesk;
    this.imageRwd = imageRwd;
    this.shortChapo = shortChapo;
    this.longChapo = longChapo;
    this.dynamicContent = dynamicContent;
    this.SearchActivation = SearchActivation;
    this.typeEtrPeriple = typeEtrPeriple;
    this.floatingBar = floatingBar;
    this.blurActivation = blurActivation;
    this.textColor = textColor;
  }

  getTypeEtrPeriple() {
    return this.typeEtrPeriple ?? '';
  }

  getTitleH1() {
    return this.title ?? '';
  }

  getImageDesk() {
    return this.imageDesk ?? {};
  }

  getImageRwd() {
    return this.imageRwd ?? {};
  }

  getShortChapo() {
    return this.shortChapo ?? '';
  }

  getlongChapo() {
    return this.longChapo ?? '';
  }

  getDynamicContent() {
    return this.dynamicContent ?? [];
  }

  getSearchActivation() {
    return this.SearchActivation ?? '';
  }

  getFloatingBar() {
    return this.floatingBar ?? '';
  }

  getBlurActivation() {
    return this.blurActivation ?? '';
  }

  getTextColor() {
    return this.textColor ?? '';
  }
}
